import {GetApplication} from '../client'
import {Applications} from '../types'

const isApplicationIAM = () => GetApplication() === Applications.IAM

export {isApplicationIAM}
